import React, { memo } from 'react';

export const SearchOption: React.FC<{ label: string; data: { highlight: string } }> = memo((props) => {
    const { label, data: { highlight } } = props;

    if (!highlight) {
        return <span>{label}</span>;
    }

    const regex = new RegExp(`(${highlight.replace(/\./g, '\\.')})`, 'ig');
    const highlights = [...label.matchAll(regex)].map(match => match[0]).filter(Boolean);
    let highlightsIndex = 0;
    const chunks = label
        .split(regex)
        .filter(Boolean)
        .reduce((acc, chunk, index) => {
            if (highlights.includes(chunk)) {
                acc.push(<b key={`${chunk}${index}`}>{highlights[highlightsIndex]}</b>);
                highlightsIndex++;

                return acc;
            }
            acc.push(chunk);

            return acc;
        }, [] as React.ReactNode[]);

    return (
        <span>
            {chunks}
        </span>
    );
});
